










import {Component, Vue} from "vue-property-decorator";
import NavComponent from "@/components/NavComponent.vue";

@Component({
    components: {
        NavComponent,
    },
})
export default class App extends Vue {

}
